import { render } from "./card-icon.vue?vue&type=template&id=0b91880a&scoped=true"
import script from "./card-icon.js?vue&type=script&lang=js&external"
export * from "./card-icon.js?vue&type=script&lang=js&external"

import "./card-icon.scss?vue&type=style&index=0&id=0b91880a&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b91880a"]])

export default __exports__